import React, { useState } from "react";

const UniditEditor = React.lazy(() => {
  return import("@techzolab/zodit-react");
});

const buttons = [
  "undo",
  "redo",
  "|",
  "bold",
  "strikethrough",
  "underline",
  "italic",
  "|",
  "superscript",
  "subscript",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  //   "outdent",
  //   "indent",
  "justify",
  "|",
  "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
];
const editorConfig = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  defaultActionOnPaste: "insert_clear_html",
  buttons: buttons,
};

export const UniEditorMedium = ({
  name,
  contents,
  onChange,
  height = 100,
  width = "100%",
  size = false,
  placeholder,
}) => {
  editorConfig.width = width;
  editorConfig.height=height;
  const initialContent = contents ?? ``;
  const [value, setValue] = useState(initialContent);
  const isSSR = typeof window === "undefined";
  const target_name = name || "description";

  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={<div>Loading RTE</div>}>
          <UniditEditor 
          config={editorConfig} 
          value={initialContent} 
          onChange={(val) => {
            setValue(val)
            if(onChange){
              const target = { name: target_name, value: val };
              onChange({ target })
            }
            }}/>
        </React.Suspense>
      )}
    </>
  );
};
export default UniEditorMedium;